import { http } from '@/services/http';
import { getInternalBasePath } from '@/shared/lib/environmentPaths';

import type { MarketGroup, MarketsListData, MarketsListItem } from '@/entities/market';

interface MarketDTO {
  insightId: string;
  metadata: {
    displayName: string;
    commodity: string;
    region: string;
    tag?: string | null;
    comingSoon?: boolean;
  };
}

interface MarketGroupDTO {
  subHeading: string;
  order: number;
  markets: MarketDTO[];
}

export const marketListApi = {
  getMarketsList: async (verificationToken?: string): Promise<MarketsListData> => {
    const { data } = await http.internal.get<MarketGroupDTO[]>(
      `${getInternalBasePath()}markets`,
      verificationToken ? { headers: { Authorization: `Bearer ${verificationToken}` } } : undefined
    );

    return {
      marketsList: data.reduce((acc, item) => {
        return [
          ...acc,
          ...item.markets.map(
            (market): MarketsListItem => ({
              marketId: market.insightId.toLowerCase(),
              metadata: {
                displayName: market.metadata.displayName,
                commodity: market.metadata.commodity,
                region: market.metadata.region
              }
            })
          )
        ];
      }, [] as MarketsListItem[]),
      groupedMarkets: data.map(
        (item): MarketGroup => ({
          name: item.subHeading,
          order: item.order,
          markets: item.markets.map(market => ({
            name: market.metadata.displayName,
            tag: market.metadata?.tag,
            comingSoon: market.metadata?.comingSoon,
            marketId: market.insightId.toLowerCase()
          }))
        })
      )
    };
  }
};
